export default __webpack_public_path__ + "static/media/blue-account-icon.0fa5b5a3.svg";